import React, { createContext, useContext, useEffect, useMemo, useState } from "react"
import i18next from "i18next"
import LanguageDetector from "i18next-browser-languagedetector"
import cs from "lang/cs.json"
import de from "lang/de.json"
import en from "lang/en.json"
import lt from "lang/lt.json"
import no from "lang/no.json"
import pl from "lang/pl.json"
import ru from "lang/ru.json"
import { I18nextProvider } from "react-i18next"
import { LocalStorageService } from "services/api-service"
import styled from "styled-components"
import Spinner from "ui/components/atoms/spinner"
import { locales } from "utils/lang.utils"

i18next.use(LanguageDetector).init({
  lng: "pl",
  resources: {
    pl: pl,
    en: en,
    de: de,
    lt: lt,
    no: no,
    cs: cs,
    ru: ru,
  },
  interpolation: { escapeValue: false }, // React already does escaping
})

export const LocaleContext = createContext<{
  locale: string
}>({
  locale: "pl",
})

export const LocaleContextProvider = ({
  locale,
  children,
}: {
  locale: string
  children: React.ReactNode
}) => {
  const query = useMemo(() => new URLSearchParams(window.location.search), [])

  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const fetchLang = async () => {
      setLoading(true)
      const lang = query.get("lang") || (await LocalStorageService.getObject("lang"))
      if (lang && locales.includes(lang)) {
        LocalStorageService.setObject("lang", lang)
        i18next.changeLanguage(lang)
      }

      setLoading(false)
    }

    fetchLang()
  }, [query])

  if (loading) {
    return (
      <InitWrapper>
        <Spinner />
      </InitWrapper>
    )
  }

  return <I18nextProvider i18n={i18next}>{children}</I18nextProvider>
}

export const useLocale = () => useContext(LocaleContext)

const InitWrapper = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.8);
`
